import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { RadioSection } from "@Shared/components/sections";
import MaterialInput from "@Shared/components/inputs/material-input";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import { mapActions } from "vuex";
import { GET_EMAIL_VALIDATION } from "@Broker/@Modules/main/store/account/account-actions";
import ApplicantSelect from "@Broker/@Modules/util-components/application/applicant-select.vue";
import FixedBanner from "@Shared/components/general/fixed-banner.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "RequestBankStatementsStep",
  components: {
    MaterialInput,
    RadioSection,
    ApplicantSelect,
    FixedBanner
  },
  mixins: [validationMixin],
  props: {
    bankStatementsRequests: {
      type: Object,
      required: true
    },
    clientEmail: {
      type: String,
      required: true
    },
    applicants: {
      type: Array,
      required: true
    }
  },
  validations() {
    return {
      bankStatementsRequests: {
        emails: {
          $each: {
            email: {
              email,
              required
            }
          }
        },
        months: {
          required
        }
      }
    };
  },
  data() {
    return {
      timeWorthOptions: [{
        label: this.$t("request-package.requestBankStatements.12months"),
        value: 12
      }, {
        label: this.$t("request-package.requestBankStatements.3months"),
        value: 3
      }]
    };
  },
  computed: {
    isValid() {
      return !this.$v.bankStatementsRequests.$invalid;
    },
    emailToAddValid() {
      return !this.$v.emailToAdd.$invalid;
    },
    computedBankMonths: {
      get() {
        return this.bankStatementsRequests.months;
      },
      set(value) {
        this.$emit("change-bank-months", _parseInt(value));
      }
    },
    mainApplicantName() {
      var _context;
      return _findInstanceProperty(_context = this.applicants).call(_context, ({
        applicantIndex
      }) => applicantIndex === 0).applicantFullName;
    }
  },
  watch: {
    isValid: {
      handler(value) {
        this.$emit("valid", value);
      },
      immediate: true
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("AccountStore", [GET_EMAIL_VALIDATION])), {}, {
    handleChangeEmails(emails) {
      this.$emit("add-bank-statement-request", emails);
    }
  })
});